import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import React, { useCallback } from 'react'

export type AITripDestinationListItemClickHandler = (item: App.SearchItem) => void

interface Props {
  item: App.SearchItem
  onClick: AITripDestinationListItemClickHandler
}

function AITripDestinationListItem({ item, onClick }: Props) {
  const handleClick = useCallback(() => {
    onClick(item)
  }, [onClick, item])

  return <ClickableListItem
    key={item.value}
    onClick={handleClick}
    size="medium"
    title={item.format.mainText}
    subtitle={item.format.secondaryText}
    startIcon={<LineMapMarkerIcon />}
  />
}

export default AITripDestinationListItem
